<template>
  <div
    class="wrapper"
    v-if="visible"
  >
    <div class="title">
      {{ $t("number_of_cases") }}:
    </div>
    <div class="scale-bar">
      <span>
        {{maximum}}
      </span>
      <span>
        {{minimum}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    minimum: {
      required: true,
      type: Number
    },
    maximum: {
      required: true,
      type: Number
    }
  },
  computed: {
    visible() {
      return this.minimum + this.maximum !== 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;

  .title {
    color: $hku-gray-1;
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.05);
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    padding-right: 4px;
    @media screen and (max-width: $breakpoint-tablet) {
      width: 180px;
      margin-left: 10px;
    }
  }

  .scale-bar {
    width: 120px;
    background-image: url(../assets/color-legend.svg);
    background-size: 100% auto;
    background-position: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 2px 4px;
    font-size: 1em;
    font-weight: 600;
    font-family: $type-number;
    color: $hku-offwhite;
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.05);
    line-height: 1.1;
    @media screen and (max-width: $breakpoint-tablet) {
      margin-right: 10px;
      width: 100%;
      border-radius: 4px;
    }

    span {
      display: block;
      padding: 0 4px;
    }
  }
}
</style>
